import { AGRITOUR_SUCCESS } from './agritour-form-copy';
import { AgriTourClicksFooter, AgriTourSiteHeader } from './AgriTourChrome';
import styles from './AgriTourScreen.module.css';

export default function AgriTourSuccess() {
  return (
    <div className={styles.successPage} dir="rtl" lang="he">
      <AgriTourSiteHeader />
      <div className={styles.successMain}>
        <div className={styles.successCard}>
          <div className={styles.successBadge} aria-hidden>
            <span className={styles.successCheck}>✓</span>
          </div>
          <h1 className={styles.successTitle}>{AGRITOUR_SUCCESS.title}</h1>
          <p className={styles.successBody}>{AGRITOUR_SUCCESS.body}</p>
        </div>
      </div>
      <AgriTourClicksFooter />
    </div>
  );
}
